export default __webpack_public_path__ + "static/media/paper cut 3.c6182a98.pdf";